var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"white","elevation":"10","rounded":"xl"}},[_c('v-img',{staticClass:"mx-auto",attrs:{"src":require("@/assets/tslc.png"),"width":"150"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }